import { useEffect, useState } from "react";
import { MetronLogo } from "@/components/MetronLogo";

export function SplashScreen() {
  const [hide, setHide] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHide(true), 1300);
    const t2 = setTimeout(() => setGone(true), 1800);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (gone) return null;

  return (
    <div
      data-testid="splash-screen"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-opacity duration-500"
      style={{
        opacity: hide ? 0 : 1,
        pointerEvents: hide ? "none" : "auto",
        background: "radial-gradient(120% 80% at 50% 40%, #133046 0%, #0C1924 60%, #08131c 100%)",
      }}
    >
      <div className="flex flex-col items-center animate-[fadeIn_0.6s_ease]">
        <MetronLogo className="h-24 w-24 drop-shadow-[0_10px_30px_rgba(73,215,220,0.30)]" />
        <h1 translate="no" className="notranslate font-heading font-bold tracking-[0.35em] pl-[0.35em] mt-3 text-5xl" style={{ color: "#F4F7FA" }}>MÉTRON</h1>
        <p className="text-sm mt-2" style={{ color: "#B8C5D0" }}>Plataforma Modular de Avaliação e Gestão de Competências</p>
        <div className="mt-6 h-[3px] w-24 rounded-full overflow-hidden" style={{ backgroundColor: "rgba(58,84,99,0.5)" }}>
          <div className="h-full w-1/2 rounded-full animate-[loadbar_1.2s_ease-in-out_infinite]" style={{ background: "linear-gradient(90deg,#D3A46F,#49D7DC)" }} />
        </div>
        <p className="text-[11px] mt-8 max-w-xs text-center leading-relaxed px-6" style={{ color: "#6E8291" }}>
          <span translate="no" className="notranslate">MÉTRON</span> — do grego "medida". Um sistema criado para transformar desempenho em avaliação objetiva, padronizada e comparável.
        </p>
      </div>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: none;} }
        @keyframes loadbar { 0% { transform: translateX(-120%);} 100% { transform: translateX(240%);} }
      `}</style>
    </div>
  );
}
